import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Button, Drawer, Spin, Popover, Affix, Result, Space } from "antd";
import Title from "antd/lib/typography/Title";
import { COLORS } from "../pages/theme";
import {
  InfoOutlined,
  RefreshOutlined,
  Close,
  KeyboardArrowDownOutlined,
  ArrowBackIosOutlined,
  SubjectOutlined,
} from "@material-ui/icons";
import { TransparentButton } from "./basic_items";
import { Link } from "react-router-dom";
import { RESTExecutor, withDomains } from "../lib/domain";
import { showErrorInNotification } from "../lib/util";
import {
  dashboard_quick_menu,
  recon_quick_menu,
  activity_quick_menu,
  reports_quick_menu,
  setting_quick_menu,
} from "../util/ui_util";

// import ReactMarkdown from "react-markdown";
const ReactMarkdown = require("react-markdown/with-html");

// const ReactMarkdown = require('react-markdown')

let packages = {
  json: {
    version: 1.0,
  },
};

const map_to_documentation = (path) => {
  console.log("path is", path);
  let path_array = path.split("/");
  // let path_array=[];
  const final_array = path_array.filter((a, index) => {
    if (a == "" || a == null || a.startsWith(":")) {
      return false;
    } else {
      return true;
    }
    //
  });

  return final_array.join("/");
};

class _BasicHeader extends Component {
  constructor(props) {
    super(props);
    console.log({ props });
    this.state = {
      help_drawer_visible: false,
      loading: false,
      menu_open: false,
      doc_content: null,
      last_fetched_path: null,
      error: false,
      affixed: false,
    };

    this.get_documentation = RESTExecutor.detail()
      .config({
        label: "docs_detail",
      })
      .callbacks(
        (success) => {
          this.setState({
            doc_content: success.result.content,
            loading: false,
          });
        },
        (error) => {
          // showErrorInNotification(error);
          this.setState({
            error: true,
            loading: false,
            error_message:
              typeof error.error_message === "string"
                ? error.error_message
                : "Sorry, the documentation page you requested does not exist.",
          });
        }
      )
      .connect(props.domains.documentation);
  }

  render() {
    const { loading, menu_open } = this.state;
    var pathName = this.props.location.pathname || "";
    let mainMenuSelected = pathName.split("/")[1];

    let menu_items = this.props.menu_items;
    let menu_content = <div></div>;
    if (Array.isArray(menu_items)) {
      switch (mainMenuSelected) {
        case "dashboard":
          menu_items = dashboard_quick_menu;
          break;
        case "processing":
          menu_items = recon_quick_menu;
          break;
        case "activity":
          menu_items = activity_quick_menu;
          break;
        case "reports":
          menu_items = reports_quick_menu;
          break;
        case "settings":
          menu_items = setting_quick_menu;
          break;
        default:
          break;
      }
      menu_content = (
        <div style={{ display: "flex", flexDirection: "column" }}>
          {menu_items.map((item, index) => {
            return (
              <Link
                to={item.url}
                style={{
                  paddingTop: 12,
                  paddingBottom: 12,
                  borderBottom:
                    index + 1 != menu_items.length
                      ? "1px solid rgba(0, 0, 0, 0.1)"
                      : null,
                }}
                onClick={(e) => {
                  this.setState({ menu_open: false });
                }}
              >
                <span
                  title={item.title}
                  style={{
                    color: pathName.includes(item.url)
                      ? COLORS.primary
                      : COLORS.secondary,
                    fontWeight: "bold",
                    lineHeight: "150%",
                    fontSize: 16,
                    marginLeft: 18,
                    maxWidth: 120,
                    width: 120,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.title}
                </span>
              </Link>
            );
          })}
        </div>
      );
    }

    return (
      <React.Fragment>
        <Affix
          className="nav-affixer"
          offsetTop={1}
          onChange={(affixed) => {
            console.log("affixed", affixed);
            this.setState({
              affixed: affixed,
            });
          }}
          style={
            {
              // zIndex:4,
              // position:'sticky'
            }
          }
        >
          <div
            ref={(ref) => {
              this.header = ref;
            }}
            id="sticky-header"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingTop: 8,
              paddingBottom: 8,
              paddingLeft: 8,
              // marginLeft: this.state.affixed?60:0,
              // marginRight: 8,
              alignItems: "center",
              backgroundColor: this.state.affixed
                ? "#fff"
                : COLORS.main_bg_color,
              transition: "all 2s",
            }}
            className="sticky-content"
          >
            <div
              style={{
                width: this.state.affixed ? 60 : 0,
                minWidth: this.state.affixed ? 60 : 0,
                // backgroundColor:'green',
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                overflow: "hidden",
                transition: "all 0.2s",
              }}
            >
              <SubjectOutlined
                titleAccess={"Toggle Sidebar"}
                className="hand-cursor"
                onClick={() => {
                  try {
                    window.slider_main
                      .toggleSlider
                      // (new_val) => {
                      //     this.setState({
                      //         slider_hidden: new_val
                      //     })
                      // }
                      ();
                  } catch (e) { }
                }}
                style={{
                  fontSize: 24,
                }}
              />
            </div>

            <div
              style={{
                flex: 1,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                // alignItems: 'center'
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flex: 1,
                  width: "100%",
                }}
              >
                {Array.isArray(menu_items) ? (
                  <Popover
                    onVisibleChange={(visible) => {
                      this.setState({ menu_open: visible });
                    }}
                    visible={menu_open}
                    overlayClassName="menu-popover"
                    arrowPointAtCenter
                    placement="bottomLeft"
                    title={"Menu"}
                    content={menu_content}
                    trigger="click"
                  >
                    <div
                      className="hand-cursor"
                      onClick={() => {
                        this.setState({ menu_open: !menu_open });
                      }}
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 10,
                        backgroundColor: menu_open
                          ? COLORS.primary
                          : COLORS.white,
                        marginRight: 12,
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <KeyboardArrowDownOutlined
                        style={{
                          color: !menu_open ? COLORS.primary : COLORS.white,
                          height: 20,
                          width: 20,
                        }}
                      />
                    </div>
                  </Popover>
                ) : null}
                {!this.props.no_back && (
                  <ArrowBackIosOutlined
                    type="left"
                    className="hand-cursor"
                    titleAccess="Back"
                    style={{
                      fontSize: 22,
                      marginRight: 12,
                    }}
                    onClick={() => {
                      if (typeof this.props.onBack === "function") {
                        this.props.onBack();
                      } else {
                        this.props.history.goBack();
                      }
                    }}
                  />
                )}
                {this.props.maintitle && (
                  <React.Fragment>
                    <span
                      title={`${this.props.maintitleType
                          ? `${this.props.maintitleType} | ${this.props.maintitle}`
                          : `${this.props.maintitle}`
                        }`}
                      style={{
                        fontSize: 24,
                        color: "#000000",
                        lineHeight: "150%",
                        whiteSpace: "nowrap",
                        marginRight: 12,
                        fontSize: 24,
                        fontWeight: "bold",
                        color: COLORS.primary,
                        lineHeight: "150%",
                        ...this.props.maintitleStyle,
                      }}
                    >
                      {this.props.maintitle}
                    </span>
                    <span
                      style={{
                        fontSize: 24,
                        color: "#000000",
                        lineHeight: "150%",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      | &nbsp; &nbsp;
                    </span>
                  </React.Fragment>
                )}
                <span
                  title={`${this.props.titleType
                      ? `${this.props.titleType} | ${this.props.title}`
                      : `${this.props.title}`
                    }`}
                  style={{
                    margin: 0,
                    marginRight: 12,
                    fontSize: 24,
                    fontWeight: "bold",
                    color: COLORS.primary,
                    lineHeight: "150%",
                    // maxWidth: 350,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    ...this.props.titleStyle,
                  }}
                >
                  {this.props.title}
                </span>
                {this.props.subtitle && (
                  <React.Fragment>
                    <span
                      style={{
                        fontSize: 24,
                        color: "#000000",
                        lineHeight: "150%",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                      }}
                    >
                      | &nbsp; &nbsp;
                    </span>
                    <span
                      title={`${this.props.subtitleType
                          ? `${this.props.subtitleType} | ${this.props.subtitle}`
                          : `${this.props.subtitle}`
                        }`}
                      style={{
                        fontSize: 24,
                        color: "#000000",
                        lineHeight: "150%",
                        // maxWidth: 450,
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        ...this.props.subtitleStyle,
                      }}
                    >
                      {this.props.subtitle}
                    </span>
                  </React.Fragment>
                )}
                {this.props.subtitle2 && (
                  <React.Fragment>
                    <span
                      style={{
                        fontSize: 24,
                        color: "#000000",
                        lineHeight: "150%",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        marginLeft: 12,
                      }}
                    >
                      | &nbsp; &nbsp;
                    </span>
                    <span
                      title={`${this.props.subtitleType2
                          ? `${this.props.subtitleType2} | ${this.props.subtitle2}`
                          : `${this.props.subtitle2}`
                        }`}
                      style={{
                        fontSize: 24,
                        color: COLORS.danger_primary,
                        lineHeight: "150%",
                        // maxWidth: 450,
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        ...this.props.subtitle2Style,
                      }}
                    >
                      {this.props.subtitle2}
                    </span>
                  </React.Fragment>
                )}
              </div>
              {this.props.bottom}
            </div>
            <div
              style={{
                paddingLeft: 12,
                // backgroundColor:'green'
                display: "flex",
                ...this.props.rightStyle,
              }}
            >
              <Space size={8}>
                {this.props.right}

                <TransparentButton
                  icon={<InfoOutlined className="btn-icon" />}
                  label="Docs"
                  onClick={() => {
                    let new_path = map_to_documentation(this.props.match.path);
                    if (this.state.last_fetched_path != new_path) {
                      this.setState({
                        loading: true,
                        error: false,
                        doc_content: null,
                        last_fetched_path: new_path,
                        help_drawer_visible: true,
                      });
                      this.get_documentation
                        .config({
                          params: { path: new_path },
                        })
                        .execute();
                    } else {
                      this.setState({
                        help_drawer_visible: true,
                      });
                    }
                  }}
                  hint="Documentation"
                />
              </Space>
            </div>
          </div>
        </Affix>

        <Drawer
          className="help-drawer"
          destroyOnClose
          width="50%"
          closable={false}
          onClose={() => {
            this.setState({
              help_drawer_visible: false,
            });
          }}
          visible={this.state.help_drawer_visible}
        >
          <div
            style={{
              height: 62,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              borderBottom: `1px solid ${COLORS.border_basic}`,
              paddingLeft: 34,
              paddingRight: 34,
              alignItems: "center",
            }}
          >
            <InfoOutlined
              titleAccess="Documentation"
              style={{
                color: COLORS.primary,
              }}
            />
            <Close
              className="hand-cursor"
              titleAccess="Close Documentation"
              onClick={() => {
                this.setState({
                  help_drawer_visible: false,
                });
              }}
            />
          </div>
          <div
            style={{
              paddingLeft: 34,
              paddingRight: 34,
              paddingTop: 15,
              overflow: "scroll",
              height: "calc(100vh - 62px)",
            }}
          >
            {loading ? (
              <center>
                <Spin />
              </center>
            ) : null}
            <ReactMarkdown
              className="markdown-render"
              escapeHtml={false}
              source={this.state.doc_content}
            />
            {this.state.error ? (
              <Result
                status="404"
                title="404"
                subTitle={this.state.error_message}
              />
            ) : null}
          </div>
        </Drawer>
      </React.Fragment>
    );
  }

  // componentDidMount(){
  //     this.observer = new IntersectionObserver(
  //         ([e]) => e.target.toggleAttribute('stuck', e.intersectionRatio < 1),
  //         {threshold: [1]}
  //       );
  //       console.log("obs",this.observer)

  //       this.observer.observe(document.getElementById('sticky-header'));
  // }

  // componentWillUnmount(){
  //     this.observer.unobserve(document.getElementById('sticky-header'))
  // }
}

export const BasicHeader = withRouter(
  withDomains(_BasicHeader, "documentation")
);
